import React from 'react';
import PropTypes from 'prop-types';
import { Dthc } from '../../../Modules';
import DescriptionEditDesktop from './DescriptionEditDesktop';
import DescriptionEditMobile from './DescriptionEditMobile';
import styles from './Description.scss';
import { Icon } from 'semantic-ui-react';
import { RootConsumer } from '../../../RootComponent';

export default class DescriptionComponent extends React.Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    localDescription: PropTypes.string,
    reset: PropTypes.func.isRequired,
    description: PropTypes.string,
    descriptionChangeHandler: PropTypes.func.isRequired,
    updateDescription: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      addingNew: false,
      selected: false
    };
    this.addNew = this.addNew.bind(this);
    this.closeNew = this.closeNew.bind(this);
  }

  addNew() {
    this.setState({ addingNew: true, selected: false });
  }

  closeNew() {
    this.setState({ addingNew: false });
  }

  render() {
    const {
      canEdit,
      localDescription,
      reset,
      description,
      descriptionChangeHandler,
      updateDescription
    } = this.props;
    const { addingNew, selected } = this.state;
    const DescriptionShow = (
      <div
        style={{ padding: '1em', wordBreak: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    );
    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div className={styles.description}>
            {canEdit &&
              <div>
                {description &&
                  <Dthc
                    desktop={DescriptionEditDesktop}
                    mobile={DescriptionEditMobile}
                    onChange={descriptionChangeHandler}
                    commitUpdate={updateDescription}
                    reset={reset}
                    value={localDescription}
                  >
                    {DescriptionShow}
                  </Dthc>}
                {!description &&
                  !addingNew &&
                  <div
                    className={styles.placeholder}
                    onClick={this.addNew}
                    onMouseOver={() => this.setState({ selected: true })}
                    onMouseOut={() => this.setState({ selected: false })}
                  >
                    {selected &&
                      <Icon className={styles.editIcon} name='write' />}
                    <em>Add a description, message, or instructions...</em>
                  </div>}
                {!description &&
                  addingNew &&
                  <div>
                    {isMobile &&
                      <DescriptionEditMobile
                        onChange={descriptionChangeHandler}
                        commitUpdate={updateDescription}
                        reset={reset}
                        closeHandler={this.closeNew}
                        value={localDescription}
                        open={addingNew}
                      />}
                    {!isMobile &&
                      <DescriptionEditDesktop
                        onChange={descriptionChangeHandler}
                        commitUpdate={updateDescription}
                        reset={reset}
                        closeHandler={this.closeNew}
                        value={localDescription}
                      />}
                  </div>}
              </div>}
            {!canEdit && DescriptionShow}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Description/Description.js